export default function getFields(vm) {
  const fields = [
    {
      key: 'licensePlate',
      label: 'global.object.licensePlate',
      header: 'licensePlate',
      thClass: 'mc-table--150',
      filter: true,
      width: 20,
      headerRowspan: 2,
      isLocked: true,
      isRedirectable: true,
    },
    {
      key: 'vehicle2Vgroup',
      label: 'global.object.fleetGroup',
      header: 'vehicle2Vgroup',
      filter: false,
      thClass: 'mc-table--150',
      headerRowspan: 2,
      isLocked: true,
    },
    {
      key: 'operationTime',
      label: 'global.object.operationTime',
      filter: false,
      isLocked: true,
      width: 30,
      children: [
        {
          key: 'operationTimeMonday',
          label: 'global.days.monday',
          header: 'operationTimeMonday',
          thClass: 'mc-table-center--120',
          tdClass: 'mc-table-center--120',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 1,
          isLocked: true,
        },
        {
          key: 'operationTimeTuesday',
          label: 'global.days.tuesday',
          header: 'operationTimeTuesday',
          thClass: 'mc-table-center--120',
          tdClass: 'mc-table-center--120',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
        },
        {
          key: 'operationTimeWednesday',
          label: 'global.days.wednesday',
          header: 'operationTimeWednesday',
          thClass: 'mc-table-center--120',
          tdClass: 'mc-table-center--120',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
        },
        {
          key: 'operationTimeThursday',
          label: 'global.days.thursday',
          header: 'operationTimeThursday',
          thClass: 'mc-table-center--120',
          tdClass: 'mc-table-center--120',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
        },
        {
          key: 'operationTimeFriday',
          label: 'global.days.friday',
          header: 'operationTimeFriday',
          thClass: 'mc-table-center--120',
          tdClass: 'mc-table-center--120',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
        },
        {
          key: 'operationTimeSaturday',
          label: 'global.days.saturday',
          header: 'operationTimeSaturday',
          thClass: 'mc-table-center--120',
          tdClass: 'mc-table-center--120',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
        },
        {
          key: 'operationTimeSunday',
          label: 'global.days.sunday',
          header: 'operationTimeSunday',
          thClass: 'mc-table-center--120',
          tdClass: 'mc-table-center--120',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
        },
      ],
      headerColspan: 7,
    },
    {
      key: 'cutOffStatus',
      label: 'global.object.status',
      header: 'cutOffStatus',
      thClass: 'mc-table--40',
      filter: false,
      width: 10,
      headerRowspan: 2,
      isLocked: true,
    },
  ]

  fields.forEach((item) => {
    if (Object.prototype.hasOwnProperty.call(item, 'children')) {
      item.children.forEach((child) => {
        child.label = vm.$t(child.label)
      })
    }
    item.label = vm.$t(item.label)
  })

  return fields
}
